// Hide header on scroll down, show on scroll up - Dawn theme compatible
(function() {
  let lastScrollTop = 0;
  const header = document.querySelector('.shopify-section-group-header-group');
  const scrollThreshold = 100;

  if (!header) {
    console.log('Header not found!');
    return;
  }

  console.log('Header found! Script is running.');

  window.addEventListener('scroll', function() {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > scrollThreshold) {
      if (scrollTop > lastScrollTop) {
        // Scrolling down — hide header
        console.log('Hiding header');
        header.style.transform = 'translateY(-100%)';
        header.style.opacity = '0';
      } else {
        // Scrolling up — show header
        console.log('Showing header');
        header.style.transform = 'translateY(0)';
        header.style.opacity = '1';
      }
    } else {
      // At top of page — always show
      header.style.transform = 'translateY(0)';
      header.style.opacity = '1';
    }

    lastScrollTop = scrollTop;
  });
})();
